// Three.js built-ins (RawShaderMaterial requires explicit declarations)
uniform mat4  projectionMatrix;
uniform mat4  viewMatrix;
uniform mat4  modelViewMatrix;
uniform vec3  cameraPosition;

in vec3  position;     // spine point world position (per-vertex)
in vec3  aTangent;     // spine tangent (per-vertex)
in float aSide;        // -1 or +1 (which side of the ribbon)
in float aAge01;       // 0..1 age along trail
in float aDistU;       // texture v coordinate along trail (tiled, can exceed 1)
in float aAlive;       // 0/1 — kill the vertex when slot is unused
in float aLeadFade;    // 0 at the live head vertex, 1 elsewhere — softens the leading edge

uniform vec3  uColor;
uniform float uStartWidth;
uniform float uEndWidth;
uniform float uStartOpacity;
uniform float uEndOpacity;
uniform float uEmissive;
uniform float uLogDepthBufFC;
uniform float uNearFadeStart;
uniform float uNearFadeEnd;

out vec2  vUv;
out float vAlpha;
out float vEmissive;
out vec3  vColor;
out float vFragDepth;

void main() {
  // View direction from spine point toward camera (world space)
  vec3 viewDir = normalize(cameraPosition - position);

  // Camera-facing perpendicular in the plane orthogonal to the tangent
  vec3 perp = cross(aTangent, viewDir);
  float pLen = length(perp);
  if (pLen < 1e-3) {
    // Tangent ≈ view direction (trail along view ray) — fall back to camera-up
    vec3 camUp = vec3(viewMatrix[0][1], viewMatrix[1][1], viewMatrix[2][1]);
    perp = cross(aTangent, camUp);
    pLen = max(length(perp), 1e-3);
  }
  perp /= pLen;

  // Width and alpha interpolated by age
  float width  = mix(uStartWidth,   uEndWidth,   aAge01);
  float alpha  = mix(uStartOpacity, uEndOpacity, aAge01);

  // Collapse vertex when slot is dead so the strip doesn't render junk
  width *= aAlive;
  alpha *= aAlive;

  // Fade the live head vertex's alpha to 0 so the ribbon's leading edge
  // emerges softly instead of starting as a hard line at the emitter.
  alpha *= aLeadFade;

  vec3 worldPos = position + perp * (aSide * 0.5 * width);

  gl_Position = projectionMatrix * viewMatrix * vec4(worldPos, 1.0);

  // Logarithmic depth buffer
  gl_Position.z = log2(max(1e-6, gl_Position.w + 1.0)) * uLogDepthBufFC - 1.0;
  gl_Position.z *= gl_Position.w;
  vFragDepth = 1.0 + gl_Position.w;

  vUv = vec2(aSide * 0.5 + 0.5, aDistU);

  // Near-camera fade — same form as the particle shader
  float viewDist = gl_Position.w;
  float nearFade = smoothstep(uNearFadeStart, uNearFadeEnd, viewDist);

  vAlpha    = alpha * nearFade;
  vEmissive = uEmissive;
  vColor    = uColor;
}
